import Vue from 'vue'
import VueRouter from 'vue-router'
// import { scriptLoader } from '../utilsOld'

// To handle navigation Duplicated Error of Vue router
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const EmailInvite = () => import('@/components/candidate/email-invite/cancel-invite')
const AppLogout = () => import('@/components/shared/logout')
const JobAd = () => import('@/components/candidate/job-search/job-ad/job-ad.component')

const VideoInterview = () => import('@/components/candidate/video-interview/index')

const ProfileVideoUpload = () => import('@/components/candidate/profile-video-upload/index')

const CloseUpTeleprompter = () => import('@/components/candidate/closeup-teleprompter/index')

const ShareVideoInterview = () => import('@/components/candidate/share-video-interview')

const VideoInterviewGuidelines = () => import('@/components/candidate/video-interview/guidelines')

const JobInterview = () => import('@/components/job/job-interview/job-interview')

// Landing pages
const CandidateRegistration = () =>
  import('@/components/registration-login/register-candidate/register-candidate.component')

const RecruiterRegistration = () =>
  import('@/components/registration-login/register-recruiter/register-recruiter.component')

const ProductDemo = () =>
  import('@/components/registration-login/product-demo/product-demo.component')

const JobCode = () => import('@/components/recruiter/jobcode/jobcode.component')

const JobVideo = () => import('@/components/recruiter/jobvideo/jobvideo.component')
// Registration / login / password pages
const ConfirmRegistrationInfo = () =>
  import(
    '@/components/registration-login/confirm-registration-info/confirm-registration-info.component'
  )

const NewPassword = () =>
  import('@/components/registration-login/forgot-password/new-password/new-password.component')

const ResetPasswordInfo = () =>
  import(
    '@/components/registration-login/forgot-password/reset-password-info/reset-password-info.component'
  )

const ForgotPasswordPage = () =>
  import('@/components/registration-login/forgot-password/forgot-password.component')

const Invitation = () => import('@/components/registration-login/invitation/invitation.component')

// Static Pages
const AboutUsPage = () => import('@/components/static-pages/about-us/about-us.component')

const PressPage = () => import('@/components/static-pages/press/press.component')
const PrivacyPolicyPage = () =>
  import('@/components/static-pages/privacy-policy/privacy-policy.component')

const ImprintPage = () => import('@/components/static-pages/imprint/imprint.component')

const TermsAndConditionsPage = () =>
  import('@/components/static-pages/terms-and-conditions/terms-and-conditions.component')
const CiBusinessTerms = () => import('@/components/recruiter/ci-business-terms/ci-business-terms')
const CiPrivacyTerms = () => import('@/components/recruiter/ci-privacy-terms/ci-privacy-terms')

const NotFound = () => import('@/components/static-pages/not-found/not-found')

const Inbox = () => import('@/components/inbox/inbox.component')

const LoginDesign = () => import('@/components/new-login-design/new-login-design')

// Admin pages
const AdminPanelUsers = () => import('@/components/admin/admin-panel/users/users.component')
const AdminPanelCompanies = () =>
  import('@/components/admin/admin-panel/companies/companies.component')
const AdminPanelProducts = () => import('@/components/admin/admin-panel/products/index.component')

const AdminPanelCompanyUsers = () =>
  import('@/components/admin/admin-panel/companies/company/users/users.component')
const AdminPanelCompanyProducts = () =>
  import('@/components/admin/admin-panel/companies/company/products/products.component')

// Candidate Specific Pages
const CandidateDashboard = () =>
  import('@/components/candidate/candidate-dashboard/index.component')

const CandidateDossier = () => import('@/components/candidate/candidate-dossier')

const CandidateSettings = () =>
  import('@/components/candidate/candidate-settings/candidate-settings.component')

const CandidateSettingsAccount = () =>
  import('@/components/candidate/candidate-settings/account.component')

const CandidateSettingsNotifications = () =>
  import('@/components/candidate/candidate-settings/notifications.component')

const CandidateCloseupV3 = () => import('@/components/candidate/closeup-v3/closeup-dashboard')
const CandidateCloseup = () => import('@/components/candidate/closeup/closeup.component')
const CloseupShopV3 = () => import('@/components/candidate/closeup-v3/closeup-shop')
const CloseupShop = () => import('@/components/candidate/closeup/shop/shop.component')
const CloseupShopBilling = () => import('@/components/candidate/closeup/shop/step2.component')
const CloseupShopPayment = () => import('@/components/candidate/closeup/shop/step3.component')
const CloseupShopConfirmPayment = () =>
  import('@/components/candidate/closeup/shop/confirm.component')

const CandidateFAQ = () => import('@/components/candidate/candidate-faq/candidate-faq.component')

const CandidateShop = () => import('@/components/candidate/candidate-shop/candidate-shop.component')

const CandidateProfile = () =>
  import('@/components/candidate/candidate-profile/candidate-profile.component')

const Profile = () =>
  import('@/components/candidate/candidate-profile-public/candidate-profile-public.component')

const CandidateProfiles = () =>
  import('@/components/candidate/candidate-profiles/candidate-profiles.component')

const JobSearch = () => import('@/components/candidate/job-search/main.component')

const CandidateCloseupOnlineOld = () =>
  import('@/components/candidate/closeup/online/closeup-online.component')

const CandidateCloseupOnline = () => import('@/components/candidate/closeup-v3/closeup-online')

const CandidateCloseupPreview = () => import('@/components/candidate/closeup-v3/cu-preview')

// Recruiter Specific Pages

const RecruitingSearch = () => import('@/components/recruiter/recruiting-search/index.vue')
const ProgressFlow = () => import('@/components/recruiter/progress-flow/index.vue')

const RecruiterShop = () => import('@/components/recruiter/recruiter-shop/recruiter-shop.component')

const RecruiterFAQ = () => import('@/components/recruiter/recruiter-faq/recruiter-faq.component')

const RecruiterSettings = () =>
  import('@/components/recruiter/recruiter-settings/recruiter-settings.component')

const BusinessProfile = () => import('@/components/recruiter/business-profile/admin-view/index.vue')

const BusinessProfilePublic = () =>
  import('@/components/recruiter/business-profile/public-view/index.vue')

const RecruiterSettingsAccount = () =>
  import('@/components/recruiter/recruiter-settings/account.component')

const RecruiterSettingsUserManagement = () =>
  import('@/components/recruiter/recruiter-settings/user-management.component')

const RecruiterSettingsCompany = () =>
  import('@/components/recruiter/recruiter-settings/company.component')

const RecruiterProgressFlow = () =>
  import('@/components/recruiter/recruiter-settings/progressFlow.vue')

const RecruiterSettingsNotifications = () =>
  import('@/components/recruiter/recruiter-settings/notifications.component')

const RecruiterSettingsIntegrations = () =>
  import('@/components/recruiter/recruiter-settings/integrations')

const CandidateManagement = () =>
  import('@/components/recruiter/candidate-management/candidate-management.component')

const CiCandidateManagement = () =>
  import('@/components/recruiter/ci-candidate-management/ci-candidate-management.component')

const CandidateDetails = () =>
  import('@/components/recruiter/candidate-details/candidate-details.component')

const CandidateEdit = () => import('@/components/recruiter/candidate-edit/index.component')

const newCiSignup = () => import('@/components/recruiter/new-ci-signup/new-ci-signup.component')

const Showrooms = () => import('@/components/recruiter/showrooms/showrooms.component')
const Showroom = () => import('@/components/recruiter/showrooms/showroom/showroom.component')

const CreateShowroom = () =>
  import('@/components/recruiter/showrooms/create-showroom/create-showroom.component')

const EditShowroom = () =>
  import('@/components/recruiter/showrooms/edit-showroom/edit-showroom.component')

// Job pages
const JobEdit = () => import('@/components/job/job-edit/job-edit.component')

const JobPreview = () => import('@/components/job/job-preview/job-preview.component')
const JobManagement = () => import('@/components/job/job-management/job-management.component')

Vue.use(VueRouter)

const candidateGuard = function (next) {
  if (localStorage.getItem('userType') === 'Candidate') {
    next()
  } else {
    next('/')
  }
}

const recruiterGuard = function (next) {
  if (localStorage.getItem('userType') === 'Recruiter') {
    next()
  } else {
    next('/')
  }
}

const candidateAndRecruiterOnlyGaurd = function (next) {
  if (
    localStorage.getItem('userType') === 'Candidate' ||
    localStorage.getItem('userType') === 'Recruiter'
  ) {
    next()
  } else {
    next('/')
  }
}

const adminGuard = function (next) {
  if (localStorage.getItem('userType') === 'User') {
    next()
  } else {
    next('/')
  }
}

const disallowRecruiters = function (next) {
  if (localStorage.getItem('userType') === 'Recruiter') {
    next('/')
  } else {
    next()
  }
}

const router = new VueRouter({
  routes: [
    {
      path: '/',
      redirect: function () {
        if (
          !['metru.de', 'www.metru.de'].includes(window.location.hostname) ||
          '?activation=true' === window.location.search
        )
          return '/signup'
        window.location.href = 'https://metru.io'
      },
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
    },
    // Unprotected Routes
    {
      path: '/candidate',
      name: 'candidate',
      component: CandidateRegistration,
    },
    {
      path: '/recruiter',
      name: 'recruiter',
      component: RecruiterRegistration,
    },
    {
      path: '/product-demo',
      name: 'product-demo',
      component: ProductDemo,
    },
    {
      path: '/jobcode-landing',
      name: 'jobcode-landing',
      component: JobCode,
    },
    {
      path: '/jobvideo-landing',
      name: 'jobvideo-landing',
      component: JobVideo,
    },
    {
      path: '/new-password',
      name: 'new-password',
      component: NewPassword,
    },
    {
      path: '/confirm-registration-info',
      name: 'confirm-registration-info',
      component: ConfirmRegistrationInfo,
    },
    {
      path: '/reset-password-info',
      name: 'reset-password-info',
      component: ResetPasswordInfo,
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: AboutUsPage,
    },
    {
      path: '/press',
      name: 'press',
      component: PressPage,
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicyPage,
    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: TermsAndConditionsPage,
    },
    {
      path: '/m/privacy-policy',
      name: 'mobile-privacy-policy',
      component: PrivacyPolicyPage,
    },
    {
      path: '/m/terms-and-conditions',
      name: 'mobile-terms-and-conditions',
      component: TermsAndConditionsPage,
    },
    {
      path: '/:companyName/business-terms',
      name: 'ci-business-terms',
      component: CiBusinessTerms,
    },
    {
      path: '/:companyName/privacy-terms',
      name: 'ci-privacy-terms',
      component: CiPrivacyTerms,
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: ImprintPage,
    },
    {
      path: '/m/imprint',
      name: 'mobile-imprint',
      component: ImprintPage,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPasswordPage,
    },
    {
      path: '/invitation-recruiter',
      name: 'invitation-recruiter',
      component: Invitation,
    },
    {
      path: '/chat',
      name: 'chat',
      component: Inbox,
    },
    {
      path: '/candidate-profiles',
      name: 'candidate-profiles',
      component: CandidateProfiles,
    },
    {
      path: '/candidate-profile/:id',
      name: 'candidate-profile',
      component: CandidateProfile,
    },
    {
      path: '/candidate-faq',
      name: 'candidate-faq',
      component: CandidateFAQ,
    },
    {
      path: '/profile/:id',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/closeup-old/:id',
      name: 'candidate-closeup-online-old',
      component: CandidateCloseupOnlineOld,
    },
    {
      path: '/closeup/:id',
      name: 'candidate-closeup-online',
      component: CandidateCloseupOnline,
    },
    {
      path: '/closeup/preview/:id',
      name: 'candidate-closeup-preview',
      component: CandidateCloseupPreview,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
    },
    {
      path: '/closeup-shop-v3',
      name: 'closeup-shop-v3',
      component: CloseupShopV3,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
    },
    {
      path: '/closeup-shop',
      redirect: '/closeup-shop/products',
      name: 'closeup-shop',
    },
    {
      path: '/closeup-shop/products',
      name: 'closeup-shop-products',
      component: CloseupShop,
    },
    {
      path: '/closeup-shop/billing',
      name: 'closeup-shop-billing',
      component: CloseupShopBilling,
    },
    {
      path: '/closeup-shop/payment',
      name: 'closeup-shop-payment',
      component: CloseupShopPayment,
    },
    {
      path: '/closeup-shop/confirm',
      name: 'closeup-shop-confirm',
      component: CloseupShopConfirmPayment,
    },
    {
      path: '/job-interview/:jobcodeId',
      name: 'job-interview',
      component: JobInterview,
    },
    {
      path: '/job-interview/:jobcodeId/:uniqueId',
      name: 'job-interview-uniqueid',
      component: JobInterview,
    },
    {
      path: '/invite/cancel/:uniqueId',
      name: 'cancel-invite',
      component: EmailInvite,
    },
    {
      path: '/video-interview/:jobcodeId',
      name: 'video-interview',
      component: VideoInterview,
      // beforeEnter: (to, from, next) => {
      //   let user = localStorage.getItem('userType')
      //   if (user === 'Recruiter' || user === 'User') {
      //     next('/')
      //   } else {
      //     next()
      //   }
      // }
    },
    {
      path: '/profile-video-upload/:jobcodeId',
      name: 'profile-video-upload',
      component: ProfileVideoUpload,
      // beforeEnter: (to, from, next) => {
      //   let user = localStorage.getItem('userType')
      //   if (user === 'Recruiter' || user === 'User') {
      //     next('/')
      //   } else {
      //     next()
      //   }
      // }
    },
    {
      path: '/closeup-teleprompter',
      name: 'closeup-teleprompter',
      component: CloseUpTeleprompter,
      // beforeEnter: (to, from, next) => {
      //   let user = localStorage.getItem('userType')
      //   if (user === 'Recruiter' || user === 'User') {
      //     next('/')
      //   } else {
      //     next()
      //   }
      // }
    },
    {
      path: '/video-interview/:jobcodeId/:uniqueId',
      name: 'video-interview-uniqueid',
      component: VideoInterview,
      // beforeEnter: (to, from, next) => {
      //   let user = localStorage.getItem('userType')
      //   if (user === 'Recruiter' || user === 'User') {
      //     next('/')
      //   } else {
      //     next()
      //   }
      // }
    },
    // Protected routes
    // admin routes
    {
      path: '/admin-panel',
      redirect: '/admin-panel/users',
    },
    {
      path: '/admin-panel/users',
      name: 'admin-panel-users',
      component: AdminPanelUsers,
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin-panel/companies',
      name: 'admin-panel-companies',
      component: AdminPanelCompanies,
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin-panel/companies/:companyId',
      name: 'admin-panel-company',
      redirect: '/admin-panel/companies/:companyId/users',
    },
    {
      path: '/admin-panel/companies/:companyId/products',
      name: 'admin-panel-company-products',
      component: AdminPanelCompanyProducts,
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin-panel/companies/:companyId/users',
      name: 'admin-panel-company-users',
      component: AdminPanelCompanyUsers,
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin-panel/products',
      name: 'admin-panel-products',
      component: AdminPanelProducts,
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/admin-panel/vouchers',
      name: 'admin-panel-vouchers',
      component: AdminPanelProducts,
      beforeEnter: (to, from, next) => {
        adminGuard(next)
      },
    },
    {
      path: '/recruiter-shop',
      name: 'recruiter-shop',
      component: RecruiterShop,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiting-search',
      name: 'recruiting-search',
      component: RecruitingSearch,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/business-profile',
      name: 'business-profile',
      component: BusinessProfile,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/business-profile/:companyId',
      name: 'business-profile-public',
      component: BusinessProfilePublic,
    },
    {
      path: '/progress-flow',
      name: 'progressFlow',
      component: ProgressFlow,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/candidate-management',
      name: 'candidate-management',
      component: CandidateManagement,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/showrooms',
      name: 'showrooms',
      component: Showrooms,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/showroom',
      name: 'showroom',
      component: Showroom,
    },
    {
      path: '/create-showroom',
      name: 'create-showroom',
      component: CreateShowroom,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/edit-showroom/:id',
      name: 'edit-showroom',
      component: EditShowroom,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/ci-candidate-management',
      name: 'ci-candidate-management',
      component: CiCandidateManagement,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/candidate-details/candidate/:id',
      name: 'candidate-details',
      component: CandidateDetails,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/candidate-edit/:id',
      name: 'candidate-edit',
      component: CandidateEdit,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/job-management',
      name: 'job-management',
      component: JobManagement,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/job-edit',
      name: 'job-edit',
      component: JobEdit,
      beforeEnter: (to, from, next) => {
        // scriptLoader(`https://maps.googleapis.com/maps/api/js?key=AIzaSyAWoiMSISXA_Kff0hCxDF6MQn0OCyCc2Xo&libraries=places`)
        recruiterGuard(next)
      },
    },
    {
      path: '/job-preview',
      name: 'jobPreview',
      component: JobPreview,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiter-faq',
      name: 'recruiter-faq',
      component: RecruiterFAQ,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiter-settings',
      name: 'recruiter-settings',
      component: RecruiterSettings,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
      redirect: '/recruiter-settings/account',
    },
    {
      path: '/recruiter-settings/account',
      name: 'recruiter-account',
      component: RecruiterSettingsAccount,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiter-settings/user-management',
      name: 'recruiter-user-management',
      component: RecruiterSettingsUserManagement,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiter-settings/company',
      name: 'recruiter-company',
      component: RecruiterSettingsCompany,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiter-settings/progress-flow',
      name: 'recruiter-progress-flow',
      component: RecruiterProgressFlow,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiter-settings/notifications',
      name: 'recruiter-notifications',
      component: RecruiterSettingsNotifications,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    {
      path: '/recruiter-settings/integrations',
      name: 'recruiter-integrations',
      component: RecruiterSettingsIntegrations,
      beforeEnter: (to, from, next) => {
        recruiterGuard(next)
      },
    },
    // candidate routes
    {
      path: '/candidate-settings',
      name: 'candidate-settings',
      component: CandidateSettings,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
      redirect: '/candidate-settings/account',
    },
    {
      path: '/candidate-settings/account',
      name: 'candidate-settings-accounts',
      component: CandidateSettingsAccount,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
    },
    {
      path: '/candidate-settings/notifications',
      name: 'candidate-settings-notifications',
      component: CandidateSettingsNotifications,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
    },
    {
      path: '/closeup-landing',
      name: 'closeup-landing',
      component: CandidateCloseup,
    },
    {
      path: '/closeup-landing-v3',
      name: 'closeup-landing-v3',
      component: CandidateCloseupV3,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
    },
    {
      path: '/Candidate-shop',
      name: 'Candidate-shop',
      component: CandidateShop,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
    },
    {
      path: '/candidate-dashboard',
      name: 'candidate-dashboard',
      component: CandidateDashboard,
      beforeEnter: (to, from, next) => {
        candidateGuard(next)
      },
    },
    {
      path: '/candidate-dossier',
      name: 'candidate-dossier',
      component: CandidateDossier,
      beforeEnter: (to, from, next) => {
        candidateAndRecruiterOnlyGaurd(next)
      },
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: JobSearch,
      beforeEnter: (to, from, next) => {
        // scriptLoader(`https://maps.googleapis.com/maps/api/js?key=AIzaSyAWoiMSISXA_Kff0hCxDF6MQn0OCyCc2Xo&libraries=places`)
        disallowRecruiters(next)
      },
    },
    {
      path: '/job/:bookingId/:companyId/:hasJobCode',
      name: 'job',
      component: JobAd,
      beforeEnter: (to, from, next) => {
        disallowRecruiters(next)
      },
    },
    {
      path: '/interview-video',
      name: 'share-interview-video',
      component: ShareVideoInterview,
    },
    {
      path: '/video-interview-guidelines/:jobcodeId',
      name: 'video-interview-guidelines',
      component: VideoInterviewGuidelines,
    },
    {
      path: '/video-interview-guidelines/:jobcodeId/:uniqueId',
      name: 'video-interview-guidelines-uniqueId',
      component: VideoInterviewGuidelines,
    },
    {
      path: '/:companyName/signup',
      name: 'ci-signup',
      component: newCiSignup,
    },
    {
      path: '/:companyName/new-ci-signup',
      name: 'new-ci-signup',
      component: newCiSignup,
    },
    {
      path: '/signup',
      name: 'signup',
      component: LoginDesign,
    },
    {
      path: '/logout',
      name: 'logging-out',
      component: AppLogout,
    },
  ],
  mode: 'history',
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
})

export default router
